<template>
  <div class="public-content">
    <div class="breadcrumb">模板页信息管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 5px;">模板页信息:</span>
        <el-input style="margin:0 10px;" v-model="searchVo.name" placeholder="请输入模板页信息" clearable></el-input>
        <span style="margin:0 5px;">是否关联设计版:</span>
        <el-select style="margin:0 10px;" v-model="searchVo.isAssociatedePtsTemplate" clearable placeholder="请选择">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
      </div>
      <div>
        <el-button round type="primary" @click="add()">新建模板页信息</el-button>
      </div>
    </div>
    <div class="right-main">
      <el-table :data="tableData" border>
        <el-table-column label="模板页信息" prop="name" width="300px"></el-table-column>
        <el-table-column label="是否关联设计版" prop="isAssociatedePtsTemplate" width="300px">
          <template slot-scope="scope"> {{ scope.row.isAssociatedePtsTemplate ? '是' : '否' }} </template>
        </el-table-column>
        <el-table-column label="信息类型">
          <template slot-scope="scope">
            <span v-if="scope.row.infoType === 'TEXT'">文本</span>
            <span v-if="scope.row.infoType === 'IMAGE'">图片</span>
          </template>
        </el-table-column>
        <el-table-column label="限制" prop="infoValue"></el-table-column>
        <el-table-column label="模板页内容" prop="content"></el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <span class="color-blue" @click="editInfo(scope)">编辑<br></span>
            <span class="color-blue" @click="deleteItem = scope.row, deleteModuleDialog = true">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <el-dialog :close-on-click-modal="false" title="删除确认" :visible.sync="deleteModuleDialog" width="500px"> 是否删除该模板页信息？ <span slot="footer" class="dialog-footer">
        <el-button @click="deleteModuleDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteModuleInfo()">确 定</el-button>
      </span>
    </el-dialog>
    <add ref="addModuleInfo" @success='onSubmit()' />
  </div>
</template>
<script>
import add from './add.vue'
import VPagination from '@/components/Pagination/index'
import { moduleInfoPage, moduleInfoAdd, moduleInfoUpdate, moduleInfoDel } from '@/api/auxx.js'
export default {
  components: {
    VPagination, add
  },
  data () {
    var value = (rule, value, callback) => {
      if (this.addModuleInfoVo.infoType === 'TEXT') {
        if (!this.addModuleInfoVo.textValue || /[^\d]/g.test(this.addModuleInfoVo.textValue)) {
          callback(new Error('请输入限制，格式为整数'))
        } else {
          callback()
        }
      } else if (this.addModuleInfoVo.infoType === 'IMAGE') {
        if (!this.addModuleInfoVo.imageValueStart || /[^\d]/g.test(this.addModuleInfoVo.imageValueStart)) {
          callback(new Error('请设置上限，格式为整数'))
        } else if (!this.addModuleInfoVo.imageValueEnd || /[^\d]/g.test(this.addModuleInfoVo.imageValueEnd)) {
          callback(new Error('请设置下限，格式为整数'))
        } else if (this.addModuleInfoVo.imageValueStart && !/[^\d]/g.test(this.addModuleInfoVo.imageValueStart) && this.addModuleInfoVo.imageValueEnd && !/[^\d]/g.test(this.addModuleInfoVo.imageValueEnd)) {
          if (this.addModuleInfoVo.imageValueStart > this.addModuleInfoVo.imageValueEnd) {
            callback(new Error('最大图片数不能小于最小图片数'))
          } else {
            callback()
          }
        }
      }
    }
    return {
      rule: {
        name: [
          { required: true, message: '请输入信息名称', trigger: 'blur' },
          { max: 20, message: '长度20个字以内', trigger: 'blur' }
        ],
        infoType: [
          { required: true, message: '请选择信息类型', trigger: 'change' }
        ],
        value: [
          { validator: value, trigger: 'blur' }
        ]
      },
      deleteModuleDialog: false,
      deleteItem: null,
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      searchVo: {
        name: ''
      },
      isEdit: false,
      infoDialog: false,
      tableData: [],
      addModuleInfoVo: {
        content: '',
        isAssociatedePtsTemplate: false,
        infoType: 'TEXT',
        imageValueStart: '',
        imageValueEnd: '',
        textValue: '',
        name: ''
      }
    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    add () {
      this.$refs.addModuleInfo.show(false)
    },
    editInfo (scope) {
      this.$refs.addModuleInfo.show(true, scope)
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    },
    deleteModuleInfo () {
      moduleInfoDel(this.deleteItem.infoId)
        .then(res => {
          if (res.data.success) {
            this.onSubmit()
            this.$message.success('删除成功')
            this.deleteModuleDialog = false
          }
        })
    },
    onSubmit () {
      moduleInfoPage({
        params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize },
        vo: this.searchVo
      })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.content
            this.queryInfo.total = res.data.data.total
          }
        })
    }
  }
}
</script>
 <style lang="less" scoped>
 .right-main {
   padding: 10px;
 }
 
 .add-category {
   justify-content: space-between;
 }
 
 .keywords {
   display: flex;
   justify-content: space-around;
   // width: 750px;
   align-items: center;
 
   .el-input {
     width: 180px;
   }
 }
 
 @deep: ~">>>";
 
 .infoValue {
   @{deep} .el-input {
     width: 40px;
 
     input {
       padding: 0 2px;
       text-align: center;
     }
   }
 }
 </style>
